import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"

export default props => (
  <StaticQuery
    query={graphql`{
  allNodeOffice(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        field_address
        relationships {
          field_icon {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                  }
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
  allNodeService(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        field_summary
        relationships {
          field_icon_purple {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
  allNodeSolution(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        field_summary
        path {
          alias
        }
        relationships {
          field_icon_white {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
  allNodeTechnology(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        field_summary
        path {
          alias
        }
        relationships {
          field_icon_white {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
}
`}
    render={data => {
			// console.log(data)

			// Gracefully handle unknown types
			let type
			try { type = props.props.relationships.field_content_type.info } catch (e) {}

			switch (type) {
				case "Office (Grid)": return <Offices entries={data.allNodeOffice.edges} baseURL={"/offices"} />
				case "Service (Grid)": return <Services entries={data.allNodeService.edges} baseURL={"/services"} />
				case "Solution (Grid)": return <Solutions entries={data.allNodeSolution.edges} baseURL={"/solutions"} />
				case "Technology (Grid)": return <Technology entries={data.allNodeTechnology.edges} baseURL={"/technology"} />
				default: return <p>Grid type not found</p>
			}
		}}
  />
)

const Offices = (data) => {
	return (
		<Container>
			<Row className={"justify-content-center"}>
				{data.entries.map((entry, key) => {
					// console.log(entry.node)
					return (
						<Col md="4" style={{
							paddingLeft: "25px", paddingRight: "25px", paddingTop: "25px", paddingBottom: "25px"
						}}
						key={key}>
							{entry.node.relationships.field_icon &&
								<img
								alt={entry.node.relationships.field_icon.field_media_image.alt}
								style={{
									maxWidth: "70px",
									maxHeight: "90px",
									margin: 0
								}}
								src={entry.node.relationships.field_icon.relationships.field_media_image.localFile.publicURL} />
							}
							<h4 style={{marginBottom: "0.25em"}}>{entry.node.title}</h4>
							<p><a href={`tel:${entry.node.field_phone_number}`}>{entry.node.field_phone_number}</a></p>
							<p>{entry.node.field_address.map((line, index) => ( <span style={{display: "block"}} key={index}>{line}</span> ) )}</p>
						</Col>
					)
				})
			}
			{!data.entries && <p>[No grid component entries found]</p> }
			</Row>
		</Container>
	)
}

//////////////////////////////////////////////////
// Services:
// No link to singles, trailing button to index
//////////////////////////////////////////////////
const Services = (data) => {
	return (
		<Container>
			<Row className={"justify-content-center"}>
			{data.entries &&
				data.entries.map((entry, key) => {
					// console.log(entry.node)
					return (
						<Col xs={12} md={8} xl={4} className={"text-left"}
							style={{paddingLeft: "25px", paddingRight: "25px", paddingTop: "25px", paddingBottom: "25px"}}
							key={key}>

								{entry.node.relationships.field_icon_purple &&
									<img
										src={entry.node.relationships.field_icon_purple.relationships.field_media_image.localFile.publicURL}
										alt={entry.node.relationships.field_icon_purple.field_media_image.alt}
										style={{height: "60px", margin: 0}}
										/>
								}
								<h3 style={{marginBottom: "0.25em"}}>{entry.node.title}</h3>
								<p style={{marginBottom: "0.5em"}}>{entry.node.field_summary}</p>
						</Col>
					)
				})
			}
			{data.entries &&
				<Col xs={12}>
					<Link to={data.baseURL} className="btn btn-secondary">Our services</Link>
				</Col>
			}
			{!data.entries && <p>[No grid component entries found]</p> }

			</Row>
		</Container>
	)
}

//////////////////////////////////////////////////
// Solutions:
// Links to singles
//////////////////////////////////////////////////
const Solutions = (data) => {
	return (
		<Container>
			<Row className={"justify-content-around"}>
			{data.entries &&
				data.entries.map((entry, key) => {
					// console.log(entry.node)
					return (
						<Col xs={12} md={8} xl={4} className={"text-left hover-bg"}
							style={{paddingLeft: "25px", paddingRight: "25px", paddingTop: "25px", paddingBottom: "25px"}}
							key={key}>

							<Link
								to={entry.node.path === undefined ? data.baseURL : entry.node.path.alias}
								style={{ color: "inherit", textDecoration: "none" }}
								>
								{entry.node.relationships.field_icon_white &&
									<img
									src={entry.node.relationships.field_icon_white.relationships.field_media_image.localFile.publicURL}
									alt={entry.node.relationships.field_icon_white.field_media_image.alt}
									style={{height: "60px", margin: 0}}
									/>
								}
								<h3 style={{marginBottom: "0.25em"}}>{entry.node.title}</h3>
								<p style={{marginBottom: "0.5em"}}>{entry.node.field_summary}</p>
								{
									entry.node.path &&
									<span style={{fontSize: "1.4rem", color: "#ffffff", paddingBottom: "2px", borderBottom: "1px solid"}}>LEARN MORE</span>
								}
							</Link>

						</Col>
					)
				})
			}
			{!data.entries && <p>[No grid component entries found]</p> }
			</Row>
		</Container>
	)
}


//////////////////////////////////////////////////
// Technology:
// Links to singles
//////////////////////////////////////////////////
const Technology = (data) => {
	return (
		<Container>
			<Row>
			{data.entries &&
				data.entries.map((entry, key) => {
					// console.log(entry.node)
					return (
						<Col xs={12} md={6} className={"text-left hover-bg"}
							style={{paddingLeft: "25px", paddingRight: "25px", paddingTop: "25px", paddingBottom: "25px"}}
							key={key}>

							<Link
								to={entry.node.path === undefined ? data.baseURL : entry.node.path.alias}
								style={{ color: "inherit", textDecoration: "none" }}
								>
								{entry.node.relationships.field_icon_white &&
									<img
									src={entry.node.relationships.field_icon_white.relationships.field_media_image.localFile.publicURL}
									alt={entry.node.relationships.field_icon_white.field_media_image.alt}
									style={{height: "60px", margin: 0}}
									/>
								}
								<h3 style={{marginBottom: "0.25em"}}>{entry.node.title}</h3>
								<p style={{marginBottom: "0.5em"}}>{entry.node.field_summary}</p>
								{
									entry.node.path &&
									<span style={{fontSize: "1.4rem", color: "#ffffff", paddingBottom: "2px", borderBottom: "1px solid"}}>LEARN MORE</span>
								}
							</Link>

						</Col>
					)
				})
			}
			{!data.entries && <p>[No grid component entries found]</p> }
			</Row>
		</Container>
	)
}
